/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A staff role the tenant defines for itself — "Nurse Practitioner", "RPN", "Phlebotomist", "Receptionist", "Office Manager". Replaces the hardcoded practitioner-type enum, and unlike it, applies to admins as well as practitioners.
 * Distinct from the AUTHORIZATION role (patient/physician/admin/manager), which is unrelated and stays as-is: that decides what the system lets you do, this describes what you are. A Receptionist and an Office Manager are both `admin` for auth and different staff roles here.
 * Records point at a role by its uuid, never by label, so a tenant can rename a role without breaking practitioner assignments or the booking concerns that require it.
 * @export
 * @interface StaffRole
 */
export interface StaffRole {
    /**
     * 
     * @type {string}
     * @memberof StaffRole
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffRole
     */
    tenant_id?: string;
    /**
     * Display name, tenant-editable and free-form. Safe to rename: nothing stores it.
     * @type {string}
     * @memberof StaffRole
     */
    label: string;
    /**
     * Compact form for dense UI and AI staff listings (e.g. "NP" for Nurse Practitioner, "RPN" for Registered Practical Nurse). Falls back to label when unset.
     * @type {string}
     * @memberof StaffRole
     */
    short_label?: string;
    /**
     * What this role's registration number is called on documents and receipts — "CNO" for Ontario nursing, "CPSO" for Ontario physicians. Falls back to a generic "Registration #" when unset.
     * @type {string}
     * @memberof StaffRole
     */
    college_label?: string;
    /**
     * Whether a member of this role may be a patient's primary practitioner. Only meaningful while the continuityOfCare module is on.
     * @type {boolean}
     * @memberof StaffRole
     */
    can_be_primary?: boolean;
    /**
     * Whether members of this role appear in per-clinician statistics (revenue, conversion, appointments-per-subscriber). Defaults to can_be_primary — the same question of who carries a panel of patients — so lab and admin roles stay out of clinician denominators.
     * @type {boolean}
     * @memberof StaffRole
     */
    counts_as_clinician?: boolean;
    /**
     * Whether members of this role may create or modify medical orders. An AUTHORIZATION question, deliberately separate from can_be_primary: a clinician may order without carrying a panel, or carry a panel without ordering. Absent means NOT EXPRESSED, not "allowed" — while physician_type still exists the legacy rule decides for that role, so setting nothing changes nothing. Once physician_type is retired, absent will mean unrestricted.
     * @type {boolean}
     * @memberof StaffRole
     */
    can_place_medical_orders?: boolean;
    /**
     * Marks the role that receives nursing work routed by role rather than by name — RPN document filing and RPN appointment assignment. At most one role per tenant should carry it; the first active holder is chosen.
     * @type {boolean}
     * @memberof StaffRole
     */
    handles_nursing_tasks?: boolean;
    /**
     * Sort position in schedules, calendars and pickers. Lower sorts first; roles without one sort last.
     * @type {number}
     * @memberof StaffRole
     */
    display_order?: number;
    /**
     * Which kinds of staff record may hold this role. Absent = any. Keeps a "Receptionist" out of the practitioner picker and a "Phlebotomist" out of the admin one.
     * @type {Array<string>}
     * @memberof StaffRole
     */
    applies_to?: Array<StaffRoleAppliesToEnum>;
    /**
     * Retired role. Hidden from pickers but never deleted, so existing staff assignments and booking concerns that reference it keep resolving.
     * @type {boolean}
     * @memberof StaffRole
     */
    inactive?: boolean;
}


/**
 * @export
 */
export const StaffRoleAppliesToEnum = {
    Physician: 'physician',
    Admin: 'admin'
} as const;
export type StaffRoleAppliesToEnum = typeof StaffRoleAppliesToEnum[keyof typeof StaffRoleAppliesToEnum];


/**
 * Check if a given object implements the StaffRole interface.
 */
export function instanceOfStaffRole(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function StaffRoleFromJSON(json: any): StaffRole {
    return StaffRoleFromJSONTyped(json, false);
}

export function StaffRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'label': json['label'],
        'short_label': !exists(json, 'short_label') ? undefined : json['short_label'],
        'college_label': !exists(json, 'college_label') ? undefined : json['college_label'],
        'can_be_primary': !exists(json, 'can_be_primary') ? undefined : json['can_be_primary'],
        'counts_as_clinician': !exists(json, 'counts_as_clinician') ? undefined : json['counts_as_clinician'],
        'can_place_medical_orders': !exists(json, 'can_place_medical_orders') ? undefined : json['can_place_medical_orders'],
        'handles_nursing_tasks': !exists(json, 'handles_nursing_tasks') ? undefined : json['handles_nursing_tasks'],
        'display_order': !exists(json, 'display_order') ? undefined : json['display_order'],
        'applies_to': !exists(json, 'applies_to') ? undefined : json['applies_to'],
        'inactive': !exists(json, 'inactive') ? undefined : json['inactive'],
    };
}

export function StaffRoleToJSON(value?: StaffRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'label': value.label,
        'short_label': value.short_label,
        'college_label': value.college_label,
        'can_be_primary': value.can_be_primary,
        'counts_as_clinician': value.counts_as_clinician,
        'can_place_medical_orders': value.can_place_medical_orders,
        'handles_nursing_tasks': value.handles_nursing_tasks,
        'display_order': value.display_order,
        'applies_to': value.applies_to,
        'inactive': value.inactive,
    };
}

